import React, { useCallback, type Dispatch } from 'react';
import { Button } from 'components/ui/button';
import { Col, Form, Row } from 'react-bootstrap-5';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

import { formatPhoneNumber } from 'helpers/formatters/phone_number_formats';
import type { ContactPhoneNumber } from 'bundles/connect/types';

type PhoneNumbersProps = {
  phoneNumbers: ContactPhoneNumber[];
  onSet: Dispatch<React.SetStateAction<ContactPhoneNumber[]>>;
}

export default function PhoneNumbers({ phoneNumbers, onSet }: PhoneNumbersProps) {
  const handleChange = useCallback((idx, changes) => {
    onSet(phoneNumbers.map((phoneNumber, index) => {
      if (index == idx) {
        return {
          ...phoneNumber,
          ...changes
        };
      }

      return phoneNumber;
    }));
  }, [phoneNumbers]);

  const handleRemove = useCallback((idx) => {
    onSet(phoneNumbers.map((phoneNumber, index) => {
      if (index == idx) {
        return {
          ...phoneNumber,
          _destroy: true
        };
      }

      return phoneNumber;
    }));
  }, [phoneNumbers]);

  const handleNew = useCallback(() => {
    onSet([...phoneNumbers, { } as ContactPhoneNumber]);
  }, [phoneNumbers]);

  return (
    <div>
      <Row className="align-items-center">
        <Col><Form.Label className="my-0">Phone Numbers</Form.Label></Col>
        <Col xs="auto">
          <Button label="+ Add New Phone Number" size="sm" variant="secondary" onClick={handleNew} />
        </Col>
      </Row>
      <div className="d-flex flex-column gap-2 mt-2">
        {phoneNumbers.map((phoneNumber, index) => {
          if (phoneNumber._destroy) return;

          return (
            <Row className="gx-2" key={`phone-number-${index}`} >
              <Col>
                <Form.Control
                  placeholder="Label"
                  required
                  value={phoneNumber.label || ''}
                  onChange={e => handleChange(index, { label: e.target.value })}
                />
              </Col>
              <Col>
                <Form.Control
                  placeholder="(000) 000-0000"
                  required
                  value={formatPhoneNumber(phoneNumber.number || '')}
                  onChange={e => handleChange(index, { number: e.target.value })}
                />
              </Col>
              <Col xs="auto">
                <Button className="text-danger" icon={faTrash} variant="ghost" onClick={() => handleRemove(index)} />
              </Col>
            </Row>
          );
        })}
      </div>
    </div>
  );
}
